import { useState } from "react";
import SelectOutputsForMassSchedule from "./SelectOutputsForMassSchedule";
import CreateMassScheduleUI from "./CreateMassScheduleUI";

const CreateMassScheduleForm = ({ selectedSites, apiData, onClose }) => {

    const [modalPageIndex, setModalPageIndex] = useState(0);
    const [selectedOutputs, setSelectedOutputs] = useState([]);

    const renderPage = () => {
        switch (modalPageIndex) {
            case 0:
                return <SelectOutputsForMassSchedule setModalPageIndex={setModalPageIndex} selectedOutputs={selectedOutputs} setSelectedOutputs={setSelectedOutputs} selectedSites={selectedSites}/>;
            case 1:
                return <CreateMassScheduleUI selectedOutputs={selectedOutputs} selectedSites={selectedSites} apiData={apiData} onClose={onClose} />
            
            default:
                return null;
        }
    };

    return renderPage();
}

export default CreateMassScheduleForm;